import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth/auth-guard.service';
import { SharedModule } from '@app/shared/shared.module';
import { ListEventsComponent } from '@app/shared/pages/list-events/list-events.component';
import { AdminGuard } from '@app/admin.guard';
import { EventWrapperComponent } from '@app/shared/pages/event-wrapper/event-wrapper.component';
import { EventTranscodersComponent } from '@app/shared/pages/event-transcoders/event-transcoders.component';
import { StyleguideComponent } from '@app/styleguide/styleguide.component';
import { HomeComponent } from '@app/home/home.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@app/auth/auth.module').then(mod => mod.AuthModule)
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'events',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ListEventsComponent,
            data: { animation: 'ListEvents' }
          },
          {
            path: 'create',
            loadChildren: () =>
              import('./event/create-event/create-event.module').then(
                module => module.CreateEventModule
              )
          },
          {
            path: ':eventId',
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: EventWrapperComponent,
                data: { animation: 'Event', name: 'EVENT_PAGE' }
              },

              {
                path: 'settings',
                loadChildren: () =>
                  import('./stream/settings/settings.module').then(
                    mod => mod.SettingsModule
                  )
              },
              {
                path: 'transcoders',
                component: EventTranscodersComponent,
                data: { animation: 'Transcoders', name: 'EVENT_TRANSCODERS' }
              }
            ]
          }
        ]
      },
      {
        path: 'uploads',
        loadChildren: () =>
          import('./uploads/uploads.module').then(
            module => module.UploadsModule
          )
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./account/account.module').then(
            module => module.AccountModule
          )
      },
      {
        path: 'engine-hints',
        loadChildren: () =>
          import('./engine-hints/engine-hints.module').then(
            module => module.EngineHintsModule
          )
      },
      {
        path: 'styleguide',
        component: StyleguideComponent
      },
      {
        path: 'admin',
        canActivate: [AdminGuard],
        data: { animation: 'ListUsersAdmin' },
        loadChildren: () =>
          import('app/admin/admin.module').then(module => module.AdminModule)
      },
      {
        path: 'logs',
        loadChildren: () =>
          import('./logs/logs.module').then(module => module.LogsModule
        )
      },

      {path: 'stream',
        loadChildren: () =>
          import('./stream-test/stream-test.module').then(
            module => module.StreamTestModule
          )
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }), SharedModule],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
